export class ApiError extends Error {
  readonly code: string
  readonly statusCode: number
  readonly correlationId: string | undefined

  constructor(
    message: string,
    code: string,
    statusCode: number,
    correlationId?: string
  ) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.statusCode = statusCode
    this.correlationId = correlationId
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
